// Mappers for blob storage related entities
// Identity mappers for 1:1 mapping

import type { AcquireStorageAccessResponseDto } from '@api/generated/models';

import type { StorageAccessResponse } from '@api/domain/types';

// Response mappers (identity for 1:1)
export const toStorageAccessResponse = (dto: AcquireStorageAccessResponseDto): StorageAccessResponse =>
  dto as unknown as StorageAccessResponse;
